import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemePreference = "light" | "dark" | "system";

export const isThemePreference = (value: unknown): value is ThemePreference => value === "light" || value === "dark" || value === "system";

interface ThemePreferenceState {
  preference: ThemePreference | null;
  setPreference: (preference: ThemePreference | null) => void;
}

export const useThemePreferenceStore = create<ThemePreferenceState>()(
  persist(
    (set) => ({
      preference: null,
      setPreference: (preference) => set({ preference }),
    }),
    { name: "max-theme-preference" },
  ),
);
